import React from "react";
import { Icon } from "@iconify/react";
const Icons = ({ icon, className, width, rotate }) => {
  return (
    <>
      <Icon
        width={width}
        rotate={rotate}
        icon={icon}
        className={className}
      />
    </>
  );
};

export default Icons;
